// ============================================================================
// COUNTING SORT - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'counting-sort',
  name: 'Counting Sort',
  category: 'Sorting',
  complexity: {
    time: 'O(n + k)',
    space: 'O(k)'
  },
  description: 'A non-comparison-based sorting algorithm that sorts by counting the number of occurrences of each distinct element in the input array. It works best when the range of potential items (k) is not significantly larger than the number of items (n).'
};
